import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { Interval, PlanType } from '@zapier/design-system-revenue/src/types';

import { upgradeModal_nextPlan as NextPlanQuery } from './types/upgradeModal_nextPlan';

const nextPlanQuery = gql`
  query upgradeModal_nextPlan(
    $accountId: Int!
    $interval: BillingInterval
    $type: String
  ) {
    nextPlanV2(accountId: $accountId, interval: $interval, type: $type) {
      amount
      id
      interval
      name
      premiumAppsLimit
      tasks
      type
      zapLimit
    }
  }
`;

type Options = {
  interval?: Interval;
  type?: PlanType;
};

export const useNextPlan = ({ interval, type }: Options = {}) => {
  const { accountId } = useCurrentAccountId();

  const { data, error, loading } = useQuery<NextPlanQuery>(nextPlanQuery, {
    skip: !accountId,
    variables: {
      accountId,
      interval,
      type,
    },
  });

  return {
    isLoading: loading,
    nextPlan: data?.nextPlanV2,
    error: error ? 'Error loading next plan information.' : undefined,
  };
};
